import { PText } from '@porsche-design-system/components-react';
import React, { memo } from 'react';
import statusColors from './StatusColors';

/* 
These are for future use with epic colors
const tailwindColors = [
  'bg-red-300',
  'bg-orange-300',
  'bg-amber-300',
  'bg-yellow-300',
  'bg-lime-300',
  'bg-green-300',
  'bg-emerald-300',
  'bg-teal-300',
  'bg-cyan-300',
  'bg-blue-300',
  'bg-indigo-300',
  'bg-purple-300',
  'bg-pink-300',
  'bg-rose-300',
];

function hashCode(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const character = str.charCodeAt(i);
    hash = (hash << 5) - hash + character;
    hash |= 0; // Convert hash to a 32-bit integer
  }
  return Math.abs(hash); // Ensure that the hash is positive
}
*/

// This function is for future use with epic colors
/* 
function getEpicColor(epicName) {
  const index = hashCode(epicName) % tailwindColors.length;
  return tailwindColors[index];
}
*/

function getTagColor(status) {
  const statusObj = statusColors.find((obj) => obj.statuses.includes(status));
  return statusObj ? statusObj.color : 'bg-red-500';
}

export const IssueCard = memo(({ issue }) => {
  const issueTagColor = getTagColor(issue.fields.status.name);
  const issueLinksWithEpic = issue.fields.issuelinks?.filter(
    (link) => link.outwardIssue?.fields.issuetype.name === 'Epic'
  );

  return (
    <div
      className="flex flex-col rounded gap-2 p-3 mb-3 cursor-pointer bg-white bg-opacity-60"
      onClick={() => window.open(`https://skyway.porsche.com/jira/browse/${issue.key}`, '_blank')}
    >
      <div className={`issue-tag ${issueTagColor} rounded-full h-2 w-4`} />

      {/* Jira Ticket No */}
      <PText color="contrast-medium" size="xx-small">
        {issue.key}
      </PText>

      <PText
        className="hyphens-auto break-words"
        size="x-small"
        weight="semi-bold"
        style={{
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}
      >
        {issue.fields.summary}
      </PText>

      {issueLinksWithEpic.map((link) => (
        <span key={link.outwardIssue.id} className="inline-block px-2 py-0.5 text-xs font-medium rounded bg-gray-200 text-gray-800">
          <PText
            key={`text-${link.outwardIssue.id}`}
            size={'xx-small'}
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 1,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {link.outwardIssue.fields.summary}
          </PText>
        </span>
      ))}

      {/*       {issueLinksWithEpic.map((link) => (
        <>
        <PTag key={link.outwardIssue.id} color="background-surface" compact="true">{link.outwardIssue.fields.summary}</PTag>

            </>
      ))}  */}
    </div>
  );
});
